import React, { Component } from 'react';
import SearchIcon from './icon/SearchIcon';
import SearchIndex from './model/SearchIndex';
import SearchInput from './SearchInput';
import Results from './Results';
import './search.css';
import Uri from 'jsuri'
import { withRouter } from 'react-router-dom';

class Search extends Component {
	constructor(props) {
		super(props);

		this.uri = new Uri(props.location.search);
		const q = this.uri.getQueryParamValue('q');

		this.state = {
			"query": q || "",
			"hits": []
		};
		this.doSearch             = this.doSearch.bind(this);
		this.clearSearch          = this.clearSearch.bind(this);
		this.onInputChange        = this.onInputChange.bind(this);
		this.index                = new SearchIndex().getIndex();
		this.startSearchTimeout   = null;
	}

	componentWillMount() {
		this.doSearch();
	}

	componentWillReceiveProps(nextProps) {
		this.uri = new Uri(nextProps.location.search);
		const q = this.uri.getQueryParamValue('q') || "";
		this.doSearch({
			"query": q
		});
	}

	clearSearch() {
		document.title = 'LiveStream.de - TV Programm mit Filmen und Serien live streamen';
		document.querySelector('meta[name="description"]').setAttribute("content", 'LiveStream.de ist der beste Weg online TV zu schauen. Sport Livestream mit Bundesliga Live, News, Unterhaltung oder Kids TV - das deutsche TV Programm Online schauen.');
		this.props.history.push(this.uri.deleteQueryParam('q').toString());
	}

	onInputChange(event) {
		clearTimeout(this.startSearchTimeout);
		let searchHolder = document.getElementById('search');

		let inputValue = event.target.value;
		if (inputValue !== '') {
			searchHolder.classList.add('typing');
		} else {
			searchHolder.classList.remove('typing');
		}
		
		this.startSearchTimeout = setTimeout(function() {
			this.props.history.push(this.uri.replaceQueryParam('q', inputValue).toString());
		}.bind(this), 200);
	}

	doSearch(stateUpdates) {
		this.setState(stateUpdates, this.executeSearch.bind(this));
	}

	executeSearch() {
		let query = this.state.query;

		this.index.search({ query: query, hitsPerPage: 100 }, function(err, content) {
			if (err) {
				console.error(err);
				return;
			}

			// Sort hits by top value desc
			content.hits.sort(function(a, b){
			    var keyA = a.top,
			        keyB = b.top;
				
				if(typeof keyA === 'undefined') keyA = 0;
				if(typeof keyB === 'undefined') keyB = 0;
			    
			    if(keyA > keyB) return -1;
			    if(keyA < keyB) return 1;

			    return 0;
			});

			this.setState({"hits": content.hits});
			this.setState({"query": query});
		}.bind(this));
	}

	render() {
		return [
			<section id="search" key="0">
				<h3 className="hide">Search</h3>
				<div className="inner">
					<div className="holder">
						<SearchIcon />
						<SearchInput clearSearch={this.clearSearch} onInputChange={this.onInputChange} query={this.state.query} />
					</div>
				</div>
			</section>,
			<section id="results" key="1">
				<Results query={this.state.query} hits={this.state.hits} index={this.index} />
			</section>
		];
	}
}

export default withRouter(Search);


// WEBPACK FOOTER //
// ./src/Search.js